(function () {
  if (window.GiftsboxlyBundleDropdown) {
    window.GiftsboxlyBundleDropdown.mount();
    return;
  }

  const text = element => (element?.textContent || '').replace(/\s+/g, ' ').trim();

  function initialize(root) {
    if (root.hasAttribute('data-bundle-dropdown-ready')) return;
    const container = root.querySelector('.quantity-breaks-container');
    if (!container) return;
    const entries = Array.from(container.querySelectorAll('.quantity-break[data-input]')).map(offer => ({
      offer,
      radio: container.querySelector('input[name="quantity"][data-input="' + offer.dataset.input + '"]')
    })).filter(entry => entry.radio);
    if (!entries.length) return;

    const control = document.createElement('div');
    control.className = 'bundle-dropdown-control';
    const label = document.createElement('label');
    label.className = 'bundle-dropdown-label';
    const select = document.createElement('select');
    select.id = root.id + '-offer-select';
    select.className = 'bundle-dropdown-select';
    select.dataset.bundleOfferSelect = '';
    label.htmlFor = select.id;
    label.textContent = 'Quantity';
    const summary = document.createElement('div');
    summary.className = 'bundle-dropdown-summary';
    summary.setAttribute('aria-live', 'polite');
    summary.setAttribute('aria-atomic', 'true');
    const amounts = document.createElement('div');
    amounts.className = 'bundle-dropdown-amounts';
    const price = document.createElement('span');
    price.className = 'bundle-dropdown-price';
    const compare = document.createElement('s');
    compare.className = 'bundle-dropdown-compare';
    const caption = document.createElement('span');
    caption.className = 'bundle-dropdown-caption';
    amounts.append(price, compare);
    summary.append(amounts, caption);
    control.append(label, select, summary);
    container.before(control);

    entries.forEach(entry => {
      entry.option = new Option('', entry.radio.dataset.input);
      select.add(entry.option);
    });

    function sync() {
      const selected = entries.find(entry => entry.radio.checked) || entries[0];
      entries.forEach(({ offer, radio, option }) => {
        const title = text(offer.querySelector('.quantity-break__label-text')) || 'Buy ' + radio.value;
        const benefit = text(offer.querySelector('.quantity-break__benefit')).replace(/^GET\s+/i, '').replace(/\s+OFF$/i, ' off');
        const amount = window.GiftsboxlyBlanketBundle?.priceForOffer?.(offer) || text(offer.querySelector('.quantity-break__price'));
        const value = [title, benefit, amount].filter(Boolean).join(' - ');
        if (option.textContent !== value) option.textContent = value;
        option.disabled = radio.disabled;
        offer.setAttribute('data-bundle-selected', String(radio === selected.radio));
        const rows = root.hasAttribute('data-blanket-bundle-root')
          ? offer.querySelector('.quantity-break__selector-item:not([data-select-index="0"])')
          : offer.querySelector('.quantity-break__selector-item');
        offer.setAttribute('data-bundle-has-details', String(!!(rows || offer.querySelector('.quantity-break__upsell'))));
      });
      select.value = selected.radio.dataset.input;
      const amount = text(selected.offer.querySelector('.quantity-break__price'));
      const original = selected.offer.querySelector('.quantity-break__compare-price');
      const originalText = original?.classList.contains('hidden') ? '' : text(original);
      const savings = text(selected.offer.querySelector('.quantity-break__caption'));
      if (price.textContent !== amount) price.textContent = amount;
      if (compare.textContent !== originalText) compare.textContent = originalText;
      compare.hidden = !originalText;
      if (caption.textContent !== savings) caption.textContent = savings;
      summary.hidden = !amount && !savings;
    }

    // Keep the native quantity event, variant selectors and cart submission intact.
    select.addEventListener('change', () => {
      entries.find(entry => entry.radio.dataset.input === select.value)?.radio.click();
      sync();
    });
    let frame;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = null; sync(); });
    };
    root.addEventListener('change', schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(container, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['checked', 'disabled'] });
    if (!entries.some(entry => entry.radio.checked)) entries[0].radio.click();
    sync();
    entries.forEach(({ radio }) => {
      radio.hidden = true;
      radio.tabIndex = -1;
      radio.setAttribute('aria-hidden', 'true');
    });
    root.setAttribute('data-bundle-dropdown-ready', '');
  }

  function mount(scope = document) {
    if (scope.matches?.('quantity-breaks[data-bundle-dropdown]')) initialize(scope);
    scope.querySelectorAll('quantity-breaks[data-bundle-dropdown]').forEach(initialize);
  }

  window.GiftsboxlyBundleDropdown = { mount };
  document.addEventListener('shopify:section:load', event => mount(event.target));
  const observer = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE && (node.matches('quantity-breaks[data-bundle-dropdown]') || node.querySelector('quantity-breaks[data-bundle-dropdown]'))) mount(node);
    }));
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  mount();
})();
